import React, { useState, useEffect, useContext } from 'react';
import Popup from 'reactjs-popup';

import useDebounce from 'hooks/useDebounce';
import { stringIsCoordinates } from 'utils/geometryUtils';
import { FaChevronDown } from 'react-icons/fa';
import { ColorContext } from 'App';

const LocationSearchInput = ({
  searchLocation,
  alertData,
  searchAutoFill,
  autoCompleteData,
  setAutoCompleteData,
  setAlertData,
  query,
  setQuery,
  widget,
}) => {
  const [clickedLocation, setClickedLocation] = useState('');
  const debouncedSearchTerm = useDebounce(query, 1000);

  const [autoCompleteNames, setAutoCompleteNames] = useState([]);

  useEffect(() => {
    if (autoCompleteData.length > 0) {
      setAutoCompleteNames(autoCompleteData.map((location) => location.description));
    }
  }, [autoCompleteData]);

  useEffect(() => {
    if (debouncedSearchTerm) {
      (async () => {
        searchAutoFill(debouncedSearchTerm);
        // searchLocation(debouncedSearchTerm);
      })();
    }
  }, [debouncedSearchTerm]);

  useEffect(() => {
    if (debouncedSearchTerm === '') {
      setAutoCompleteData([]);
      setAutoCompleteNames([]);
    }
    if (stringIsCoordinates(debouncedSearchTerm)) {
      setAutoCompleteData([]);
      setAutoCompleteNames([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <form
      className="d-flex flex-column flex-sm-row"
      onSubmit={(e) => {
        e.preventDefault();
        searchAutoFill(query);
      }}
    >
      <div className="flex-grow-1">
        <input
          className="form-control bg-primary"
          list="autoCompleteNames"
          name="searchLocation"
          value={clickedLocation ? clickedLocation : query}
          autoComplete="off"
          onChange={(e) => {
            const inputValue = e.target.value;
            const autoCompleteOption = autoCompleteData.find(
              (location) => location.description === inputValue,
            );

            if (clickedLocation) {
              setClickedLocation('');
            }

            setQuery(inputValue);

            setAlertData({ ...alertData, searchLocation: autoCompleteOption });
            setClickedLocation(inputValue);
          }}
          placeholder="Search Location"
          onSubmit={searchLocation}
        />
      </div>

      <datalist id="autoCompleteNames">
        {autoCompleteNames.map((name, index) => {
          return <option key={index} value={name} />;
        })}
      </datalist>

      {!widget && (
        <div className="flex-grow-1 flex-sm-grow-0">
          <button className="form-control btn btn-secondary">Search</button>
        </div>
      )}
    </form>
  );
};

export default LocationSearchInput;
